import type { RNGConfig } from "./RNGConfig.type"

export default function resetEntityRngConfig(
  entityId: number,
  rng: RNGConfig,
): void {
  rng.seed = entityId
  rng.state = entityId
}